export default "/images/ar.png?55390eeaad2c0815c660836af6b204d7";